"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eachDurationOfInterval = void 0;
const date_fns_1 = require("date-fns");
/**
 * @summary Returns the array of dates separated by the duration within the specified interval.
 *
 * Returns an array of dates, where each date is separated by the specified duration from the last, within the
 * given interval. Note that the start time is taken as-is, none of the date parts will be zeroed. If specific
 * parts of the dates must be zeroed, it should be done before calling this function.
 *
 * @param {Interval} interval
 * @param {Duration} duration
 * @returns {Date[]}
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 * @throws {RangeError} The duration must be positive
 *
 * @example
 * // returns a list of dates separated by five hours and thirty minutes, starting at midnight
 * const eventTimes = eachDurationOfInterval({ start: startOfToday(), end: endOfToday() }, { hours: 5, minutes: 30 });
 */
function eachDurationOfInterval(interval, duration) {
    const startDate = (0, date_fns_1.toDate)(interval.start);
    const endDate = (0, date_fns_1.toDate)(interval.end);
    if (!(0, date_fns_1.isValid)(startDate) || !(0, date_fns_1.isValid)(endDate) || startDate.getTime() > endDate.getTime()) {
        throw new RangeError('Invalid interval');
    }
    const diff = (0, date_fns_1.differenceInMilliseconds)((0, date_fns_1.add)(startDate, duration), startDate);
    if (diff <= 0) {
        throw new RangeError('Invalid duration');
    }
    const dates = [];
    let currentDate = startDate;
    const endTime = endDate.getTime();
    while (currentDate.getTime() <= endTime) {
        dates.push(currentDate);
        currentDate = (0, date_fns_1.add)(currentDate, duration);
    }
    return dates;
}
exports.eachDurationOfInterval = eachDurationOfInterval;
